import './NavTabsWrapper.css';

import classNames from 'classnames';
import type { FC } from 'react';
import type { CSSProperties, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  fullHeight?: boolean;
}

export const NavTabsWrapper: FC<Props> = (props) => (
  <div
    className={classNames(
      'nav-tabs-wrapper',
      props.fullHeight ? 'flex-1' : 'flex-initial',
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </div>
);
